import React, { FC, memo } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { FreeMode } from 'swiper/modules'
import { CardProduct } from '../loading-indicator/CardProduct'
import 'swiper/css'
import 'swiper/css/free-mode'
import './ProductCardCarousel.css'
import { CardData, Product } from '../../api/types'

const toCardProduct = (p: Product): Product => ({
  images: p.images ?? [],
  oldPrice: p.oldPrice ?? undefined,
  price: p.price ?? undefined,
  subtitle: p.subtitle ?? '',
  title: p.title ?? '',
})

const ProductCardCarouselComponent: FC<{
  items: CardData[]
  setCard: (val: string) => void
}> = ({ items, setCard }) => {
  return (
    <div className="slider-container">
      <Swiper
        modules={[FreeMode]}
        spaceBetween={0}
        slidesPerView="auto"
        freeMode={{
          enabled: true,
          sticky: true,
          momentumRatio: 0.5,
          momentumVelocityRatio: 0.5,
          momentumBounceRatio: 0.1,
        }}
        centeredSlides={false}
        slidesOffsetBefore={0}
        slidesOffsetAfter={0}
        watchSlidesProgress={true}
        normalizeSlideIndex={false}
        className="grid-slider"
      >
        {items?.map(item => {
          const product = item.product ? toCardProduct(item.product) : null
          return (
            <SwiperSlide
              key={item.cardId}
              className="carousel-item"
              onClick={() => setCard(item.cardId)}
            >
              {product && <CardProduct product={product} />}
            </SwiperSlide>
          )
        })}
      </Swiper>
    </div>
  )
}

export const ProductCardCarousel = memo(ProductCardCarouselComponent)
